import { EqlAttributesConfigurationDc, GeometryType } from "@evergis/api";
import { EditGeometryType } from "../../../evergis/core/attributes/geometryTypes";
import { LayerAttribute } from "../EditResource/components/Layer/LayerAttributeItem";
import { EqlAttribute } from "../EditResource/components/QueryLayerResource/types";
import { EditResourceProps } from "../SelectFiles/Edit/EditResource";

export enum NewLayerStep {
  Type,
  Attributes,
}

export type NewLayerContextType = Partial<EditResourceProps> & {
  geometryType?: GeometryType | EditGeometryType;
  setGeometryType?: (geometryType: GeometryType) => void;
  attributes?: EqlAttribute[];
  updateAttribute?: (name: string, attributeUpdate: Partial<EqlAttribute>) => void;
  setAttributes?: (attributes: EqlAttribute[]) => void;
  deleteAttribute?: (name: string) => void;
  deleteSysAttribute?: (name: string) => void;
  sysAttributes?: LayerAttribute[];
  addSysAttributes?: (attributes: LayerAttribute[]) => void;
  addAttribute?: (attribute: EqlAttribute) => void;
  attributesConfiguration?: EqlAttributesConfigurationDc;
  setDisplayField?: (displayField: string) => void;
};
